import React from "react";
import styled, { css } from "styled-components";
import { ExternalLink } from "./ExternalLink";

const PRIVACY_URL = "https://leantech.me/legal/privacy"
const TERMS_CONDITIONS_URL = "https://leantech.me/legal/end-user-agreement"

const LEGAL_NOTICE = styled.p`
  text-align: center;
  color: #afb6b6;
  font-size: 12px;
  margin-bottom: 32px;
  
  a {
    color: #0080ff;
    margin-left: 5px;
    margin-right: 5px;
  }

  ${(props) =>
    props.bottom &&
    css`
      margin-top: auto;
    `};
`;

const LegalNotice = ({
  Continue
}) => {

  return (
    <LEGAL_NOTICE>
      By pressing "{Continue}" you agree to
        <ExternalLink onClick={() => { window.location.href = PRIVACY_URL }}>
          Lean’s Privacy Notice
        </ExternalLink>
      and
        <ExternalLink onClick={() => { window.location.href = TERMS_CONDITIONS_URL }}>
          End User Agreement.
        </ExternalLink>
    </LEGAL_NOTICE>
  );
};



export default LegalNotice;
